import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { getSiteId, isLoggedIn } from 'signin-app/login/selectors';
import { guestReturnTo } from './guest-return-to';
const GuestSignInOutFlow = React.lazy(() => import('@famly/nux_signin-guest_business-logic').then(module => ({ default: module.GuestSignInOutFlow })));
// A plain route rather than a PrivateRoute: guests sign in before anyone has typed a PIN, and on
// QR-only sites, both of which PrivateRoute redirects away from.
export const GuestScreen = () => {
    var _a;
    const history = useHistory();
    const location = useLocation();
    const loggedIn = useTypedSelector(isLoggedIn);
    const siteId = useTypedSelector(getSiteId);
    const returnTo = guestReturnTo((_a = location.state) === null || _a === void 0 ? void 0 : _a.returnTo);
    // Replace, so a tablet cycling through guests does not pile up history. Kept stable because the
    // flow's inactivity timer restarts whenever it changes.
    const onExit = React.useCallback(() => history.replace(returnTo), [history, returnTo]);
    if (!loggedIn || !siteId) {
        return _jsx(Redirect, { to: "/" });
    }
    return (_jsx(React.Suspense, { fallback: null, children: _jsx(GuestSignInOutFlow, { siteId: siteId, onExit: onExit }) }));
};
